import { useCallback } from 'react';
import PropTypes from 'prop-types';
import once from 'lodash/once';

import { useIntl } from 'react-intl';

import { isValidHttpUrl } from 'src/utils/url';

import Html5QrcodeScannerPlugin from './QrScannerPlugin';

const redirectTo = (url) => {
    window.location = url;
};

const onceRedirectTo = once(redirectTo);

const QrScanner = ({ pushNotification }) => {
    const intl = useIntl();

    const handleQrCodeError = useCallback((error) => {
        pushNotification({
            message: intl.formatMessage({ id: error }),
            isDismissButtonEnabled: true,
            timeout: 6000
        });
    }, [pushNotification]);

    const handleQrCodeScanned = useCallback((link) => {
        if (isValidHttpUrl(link) && link.includes('apetit.io')) {
            onceRedirectTo(link);
        } else {
            handleQrCodeError(intl.formatMessage({ id: 'App.invalidQrCode' }));
        }
    }, []);

    return (

        <div>
            <Html5QrcodeScannerPlugin
              fps={10}
              qrBox={200}
              disableFlip={false}
              onQrcodeScanned={handleQrCodeScanned}
              onQrcodeError={handleQrCodeError}
            />
        </div>
    );
};

QrScanner.propTypes = {
    pushNotification: PropTypes.func.isRequired
};

QrScanner.defaultProps = {
};

export default QrScanner;
